import { Component, Input } from "@angular/core";
import { ClipboardService } from "ngx-clipboard";
import { Share } from "@capacitor/share";
import { MessageService } from "src/services/message/message.service";
import { referralQueryParamKey } from "src/services/referral/referral.service";
import { getFrontendDomain } from "src/services/utils/runtime.utils";

@Component({
  selector: "rc-referral-code",
  templateUrl: "./referral-code.component.html",
  styleUrls: ["./referral-code.component.scss"],
  standalone: false,
})
export class ReferralCodeComponent {
  @Input() public referralPromoCode: string;

  public sharing: boolean = false;

  constructor(
    private readonly clipboardService: ClipboardService,
    private readonly messageService: MessageService,
  ) {}

  public async copyCode(): Promise<void> {
    this.clipboardService.copy(this.referralPromoCode);
    await this.messageService.presentSuccessToast("Code copied");
  }

  public async share(): Promise<void> {
    try {
      this.sharing = true;
      if (await Share.canShare()) {
        await this.shareWithOsModal();
      } else {
        await this.copyLinkToClipboard();
      }
    } catch (error) {
      const isWebCancelledError = error.name === "AbortError";
      const isIosCancelledError = error.message === "Share canceled";
      if (isWebCancelledError || isIosCancelledError) {
        return;
      }
      await this.copyLinkToClipboard();
    } finally {
      this.sharing = false;
    }
  }

  private async shareWithOsModal(): Promise<void> {
    await Share.share({
      title: "Subscribe through this link to get 10% off!",
      url: this.getShareUrl(),
      dialogTitle: "Subscribe through this link to get 10% off!",
    });
  }

  private async copyLinkToClipboard(): Promise<void> {
    this.clipboardService.copy(this.getShareUrl());
    await this.messageService.presentSuccessToast("Referral link copied");
  }

  private getShareUrl(): string {
    return `${getFrontendDomain().toString()}?${referralQueryParamKey}=${this.referralPromoCode}`;
  }
}
